import {Button, Card, Chip, Grid } from '@mui/material/';
import dummyMentors from './../json/top3mentors';
import React, {useEffect, useState} from "react";
import { Link, useLocation } from "react-router-dom";
import mentor_pic from './../mentor_pic.jpeg';
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import MenuAppBar from "../components/MenuAppBar";
import * as constants from './../constants'

export default function TopMentors() {
    const [error, setError] = useState('')
    const [mentors, setMentors] = useState(dummyMentors)

    const navigate = useNavigate();

    const {state} = useLocation();
    useEffect(() => {
        axios.get(constants.serverURL + "topMentors",      {
            withCredentials: true,
        }).then(response => {
            setMentors(response.data)
        }).catch((error) => {
            if (error.request.responseText === 'expired token') {
                window.location.href = constants.websiteURL + '#/refreshToken?redirect=topMentors'
            } else {
                setError(error.request.responseText)
            }
        })
    }, [])

    const bookSession = (mentor) => {
        navigate('/booksession?mentorId=' + mentor.id, {state:{mentor:mentor}});
    };

    return (
        <div>
            <MenuAppBar title="" signedIn={true}></MenuAppBar>
                <div className="screen">
                <p className="center-align font-20">Here are your Mentors!</p>
                <Grid container spacing={3} className="mentor-container">
                {
                    mentors.map(mentor => (
                        //<Grid item xs={12} sm={6} md={4} className="center-align" key={mentor.id}>
                        <Grid item xs={12} sm={6} md={4} className="center-align" key={mentor.id}>
                            <Card id={mentor.id} className="mentor-card">
                                <p className="center-align font-18">{mentor.name}</p>
                                <img
                                src={constants.mentorImageBucketURL + mentor.id + '.png'}
                                alt="Not Found"
                                className="circle"
                                />
                                <p className="center-align font-16">{mentor.score}% match</p>
                                <div className="similarity-chips">
                                {
                                    mentor.similarities.map(similarity => (
                                        <Chip className="font-12" key={similarity} label={similarity} variant="outlined" sx={{m:'2px'}}/>
                                    ))
                                }
                                </div>
                                <p className="center-align font-14">{mentor.description}</p>
                                <div className="button-group center-align">
                                    <Button className="m-form-button" variant="outlined" onClick={() => bookSession(mentor)}>Book a session</Button>
                                    {/* <Button className="m-form-button" variant="outlined">Get to know them more</Button> */}
                                </div>
                            </Card>
                        </Grid>
                    ))
                }
                </Grid>
                <Link className="font-16 primary-color" to="/allmentors">Check our other mentors here &gt;&gt;</Link>
                <Link className="font-16 primary-color" to="/menteeform">Take the survey again &gt;&gt;</Link>
            </div>
        </div>
    )
}
